import { render } from "./app-expand.vue?vue&type=template&id=136c7bbc"
import script from "./app-expand.vue?vue&type=script&lang=js"
export * from "./app-expand.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/expand/app-expand.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "136c7bbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('136c7bbc', __exports__)) {
    console.log('reload')
    api.reload('136c7bbc', __exports__)
  }
  
  module.hot.accept("./app-expand.vue?vue&type=template&id=136c7bbc", () => {
    console.log('re-render')
    api.rerender('136c7bbc', render)
  })

}


export default __exports__